import Api from "../apiService";

class CommentsApi {
  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/comments`,
      data,
      Api.authHeaders()
    );
  }

  destroy(companyId, id) {
    return Api.deleteRequest(
      `companies/${companyId}/comments/${id}`,
      Api.authHeaders()
    );
  }
}

export default new CommentsApi();
